<template>
  <div @click="download" class="download-button">
    <div class="label"><slot /></div>
    <img src="../assets/arrow-down.svg">
  </div>
</template>

<script>
export default {
  name: 'DownloadButton',
  props: ['url'],
  methods: {
    download() {
      window.open(this.url);
    },
  },
};
</script>

<style lang="stylus" scoped>
  @require '../style/colors'

  .download-button
    display: flex
    align-items: center
    justify-content: space-between
    padding: 16px 24px
    font-size: 24px
    font-weight: 700
    color: $primary-color
    border: 2px solid $primary-color
    cursor: pointer

    img
      width: 40px

    &:hover
      box-shadow: inset 0 0 0 2px $primary-color

</style>
